class Add_To_Group {
    static path = 'group-actions/add-remove-from-group';

    constructor(mutator){
        this.title = 'Add or Remove from Group';
        this.addInput("Determining Condition", "boolean");
        this.addInput("User", "user,user_id");
        this.addInput("Group", "group,group_id");
        this.bgcolor = '#dea059';
        this.desc = 'Add or remove a user from a specific group';

        this.properties = {operation: ''}
        this.addWidget("combo", "", '', {property: "operation", values: ['Add to Group', 'Remove from Group']});
    }

    getTitle() {
        if(this.properties.operation) return this.properties.operation;
        return this.title;
    }
}

module.exports = Add_To_Group
